module.exports = __webpack_public_path__ + "static/media/custom.569f7428.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/custom.png
// module id = 215
// module chunks = 0